import React from 'react';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage } from '../../util/reactIntl';
import FileUploadField from '../../components/FilesUploadField/FileUploadField';

import css from './FileUploadForm.module.css';

const FilesField = (props) => {
  const {
    fieldName,
    label,
    id,
    mutatorsPush,
    placeholder,
    isDocumentField,
    usePreviewIcon
  } = props;

  return (
    <div className={css.filesField} id={id}>
      <div className={css.fileFieldsWrapper}>
        <FieldArray name={fieldName}>
          {({ fields }) => {
            return fields.map((name, index) => {
              
              const defaultFields = !!fields.value[index] ? (
                <div className={css.fileWrapper}>
                  <FileUploadField
                    key={`${name}`}
                    id={`${name}`}
                    name={`${name}`}
                    className={css.dynamicField}
                    addNewEmpty={() => mutatorsPush(fieldName, undefined)}
                    remove={() => fields.remove(index)}
                    usePreviewIcon={usePreviewIcon}
                  />
                </div>
              ) : (
                <div className={css.fileWrapper}>
                  <FileUploadField
                    key={`${name}`}
                    id={`${name}`}
                    name={`${name}`}
                    className={css.dynamicField}
                    addNewEmpty={() => mutatorsPush(fieldName, undefined)}
                    remove={() => fields.remove(index)}
                    usePreviewIcon={usePreviewIcon}
                  />
                </div>
              );

              const content = isDocumentField ? (
                <div className={css.fileWrapper}>
                  <FileUploadField
                    key={`${name}`}
                    id={`${name}`}
                    name={`${name}`}
                    className={css.dynamicField}
                    addNewEmpty={() => mutatorsPush(fieldName, undefined)}
                    remove={() => fields.remove(index)}
                    usePreviewIcon={usePreviewIcon}
                  />
                </div>
              ) : (
                defaultFields
              );

              return content
            });
          }}
        </FieldArray>
      </div>
    </div>
  );
};

export default FilesField;
